import React, { Fragment, useContext } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { DispatchChimeContext, actionTypes } from '../context';

import Footer from './footer';

const Confirmation = () => {
  const chimeDispatch = useContext(DispatchChimeContext);

  const setDrawerStatus = (state) => {
    chimeDispatch({
      type: actionTypes.SET_CHIME_DRAWER_STATUS,
      state,
    });
  };

  const closeHandler = () => {
    setDrawerStatus(false);
  };

  return (
    <Fragment>
      <div className="m-chime-drawer__content confirmation">
        <Grid container spacing={2} className="header">
          <Grid item xs={12}>
            <span className="chime-logo" />
          </Grid>
          <Grid item xs={12} className="description">
            <span className="Heading5">Chime setup instructions sent.</span>
          </Grid>
          <Grid item xs={12}>
            Setup instructions have been sent to the email address provided.
            <br />
            After the user has completed the instructions provided they will
            have access
            <br />
            to video settings.
          </Grid>
        </Grid>
      </div>
      <Footer cancelOnClick={closeHandler} cancelText="Close" hideSave />
    </Fragment>
  );
};

export default Confirmation;
